export default __webpack_public_path__ + "static/media/Icon-trending-up.311dc1ef.svg";